/*
 * @Author: yukizou yukizou@tencent.com
 * @Date: 2025-08-20 16:20:33
 * @LastEditors: yukizou yukizou@tencent.com
 * @LastEditTime: 2025-08-20 20:50:06
 */
import { useStore } from '@/store/index';
import { ModelMetaFeed } from '@/types/model';
import { Drama } from '@/types/drama';
import { report } from '@/libs/report';
import { IS_SSR } from '@/utils/env';

export default function userDramaContaierReport() {
  const { state } = useStore();
  const { growthTestData, isFullScreen } = state;

  const dramaVideoOpt = {
    feed_id: '',
    video_Source: growthTestData?.dataSource,
    play_status: isFullScreen ? 2 : 1,
    collection_id: '',
    jump_miniApp: 2,
  };

  const dramaContainerReport = {
    mountedHotDramaReport(drama: Drama, index: number) {
      if (IS_SSR) return;
      report('drama.video.exposure', {
        type: { // 灯塔上报参数
          ...dramaVideoOpt,
          num: index,
          micro_drama_id: drama.id,
        },
      });
    },
    hotDramaClick(drama: Drama, index: number, feed: ModelMetaFeed) {
      report('drama.video.click', {
        type: { // 灯塔上报参数
          ...dramaVideoOpt,
          feed_id: feed.id,
          num: index,
          micro_drama_id: drama.id,
        },
      });
    },
    dramaReplayExpose() {
      const { dramaList, activeIndex, isFullScreen } = state;

      report('drama.again.exposure', {
        type: { // 灯塔上报参数
          collection_id: '',
          micro_drama_id: dramaList[activeIndex]?.id,
          play_status: isFullScreen ? 2 : 1,
        },
      });
    },
    dramaReplayClick() {
      const { dramaList, activeIndex, isFullScreen } = state;

      report('drama.again.click', {
        type: { // 灯塔上报参数
          collection_id: '',
          micro_drama_id: dramaList[activeIndex]?.id,
          play_status: isFullScreen ? 2 : 1,
        },
      });
    },
    dramaOpenExpose() {
      const { dramaList, activeIndex, isFullScreen } = state;

      report('drama.open.exposure', {
        type: { // 灯塔上报参数
          collection_id: '',
          micro_drama_id: dramaList[activeIndex]?.id,
          play_status: isFullScreen ? 2 : 1,
        },
      });
    },
    dramaOpenClick() {
      const { dramaList, activeIndex, isFullScreen } = state;

      report('drama.open.click', {
        type: { // 灯塔上报参数
          collection_id: '',
          micro_drama_id: dramaList[activeIndex]?.id,
          play_status: isFullScreen ? 2 : 1,
        },
      });
    },
    dramaMove() {
      const { dramaList, activeIndex, isFullScreen } = state;

      report('video.movebar.move', {
        type: { // 灯塔上报参数
          collection_id: '',
          micro_drama_id: dramaList[activeIndex]?.id,
          play_status: isFullScreen ? 2 : 1,
        },
      });
    },
    fullScreenClick(status: boolean) {
      const { dramaList, activeIndex, isFullScreen } = state;

      report('full.screen.click', {
        type: { // 灯塔上报参数
          collection_id: '',
          micro_drama_id: dramaList[activeIndex]?.id,
          btn_status: status ? 1 : 0,
          play_status: isFullScreen ? 2 : 1,
        },
      });
    },
    shareBtnClick() {
      const { dramaList, activeIndex, isFullScreen } = state;

      report('jump.weishi.click', {
        type: {
          jump_miniApp: 2,
          collection_id: '',
          micro_drama_id: dramaList[activeIndex]?.id,
          play_status: isFullScreen ? 2 : 1,
          pull_pos: 2,
        },
      });

      report('call.app.popup.exposure', {
        type: {
          collection_id: '',
          micro_drama_id: dramaList[activeIndex]?.id,
          play_status: isFullScreen ? 2 : 1,
          clk_position: 'jump.weishi',
        },
      });
    },
  };
  return dramaContainerReport;
};
